import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { PageContext, RedirectorPaynowConfig } from 'src/app/service/redirector.service'
import { PaynowFrequentQuestions } from 'src/static/content/paynow-faq.questions'
import { IconComponent } from 'src/app/elements/icon/icon.component'
import { NgIf, NgStyle } from '@angular/common'
import { PriceComponent } from 'src/app/elements/price/price.component'
import { TooltipComponent } from 'src/app/elements/tooltip/tooltip.component'
import { ButtonComponent } from 'src/app/elements/button/button.component'
import { PaymentMethodsComponent } from 'src/app/elements/payment-methods/payment-methods.component'
import { ContentBlockComponent } from 'src/app/elements/content-block/content-block.component'
import { AccordionComponent } from 'src/app/elements/accordion/accordion.component'
import { PopupComponent } from 'src/app/elements/popup/popup.component'
import { FitTextDirective } from 'src/app/directives/fit-text.directive'
import { I18nSelectorComponent } from 'src/app/elements/i18n-selector/i18n-selector.component'
import { Environment } from 'src/environments/environment'
import { PriceSuggestionComponent } from 'src/app/elements/price-suggestion/price-suggestion.component'
import { ActivatedRoute, RouterLink } from '@angular/router'
import { Subject, takeUntil } from 'rxjs'
import { OfferExpiredNoteComponent } from 'src/app/elements/offer-expired-note/offer-expired-note.component'
import { RuntimeService } from 'src/app/service/runtime.service'
import { PaynowBuyButtonsComponent } from 'src/app/elements/paynow-buy-buttons/paynow-buy-buttons.component'

@Component({
  selector: 'app-paynow-layout',
  templateUrl: './paynow-layout.component.html',
  styleUrl: './paynow-layout.component.sass',
  imports: [
    IconComponent,
    NgStyle,
    PriceComponent,
    TooltipComponent,
    ButtonComponent,
    PaymentMethodsComponent,
    ContentBlockComponent,
    AccordionComponent,
    NgIf,
    FitTextDirective,
    I18nSelectorComponent,
    RouterLink,
    PaynowBuyButtonsComponent,
  ],
})
export class PaynowLayoutComponent implements OnInit, OnDestroy {
  protected unsubscribe = new Subject<void>()
  @Input() context!: PageContext<RedirectorPaynowConfig>
  @Input({ required: true }) usps!: {
    icon: string
    head: string
    body: string
  }[]
  protected readonly PaynowFrequentQuestions = PaynowFrequentQuestions

  constructor (
    protected dialog: MatDialog,
    protected route: ActivatedRoute,
    protected runtimeService: RuntimeService,
  ) {
  }

  ngOnInit () {
    if (this.runtimeService.isServer()) {
      return
    }

    this.route.queryParams
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        if (params['offer_expired']) {
          this.dialog.open(OfferExpiredNoteComponent, {
            maxHeight: '100vh',
            maxWidth: 'calc(100vw - 30px)',
            data: this.context,
          })
        }
      })
  }

  ngOnDestroy () {
    this.unsubscribe.next()
    this.unsubscribe.complete()
  }

  openPopup (): void {
    this.dialog.open(PopupComponent, {
      maxHeight: '100vh',
      maxWidth: 'calc(100vw - 30px)',
      data: {
        url: `${Environment.url.app}/public/api/domain/offers/tax-info?domain=${this.context.config.name}&lang=${this.context.i18n.locale}`,
      },
    })
  }

  openPriceSuggest () {
    this.dialog.open(PriceSuggestionComponent, {
      maxHeight: '100vh',
      maxWidth: 'calc(100vw - 30px)',
      data: this.context,
    })
  }
}
